'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var admin = exports.admin = 'Admin';
var developer = exports.developer = 'Developer';
var config = exports.config = 'Config';
var readOnly = exports.readOnly = 'Readonly';
var standard = exports.standard = 'Standard';

var isAllowed = exports.isAllowed = function isAllowed(allowedRoles, userRoles) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = allowedRoles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var allowedRole = _step.value;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = userRoles[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var userRole = _step2.value;

          if (userRole === allowedRole) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
};

exports.default = [admin, developer, config, readOnly, standard];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/UserContainer/roles.js
 ** module id = 36
 ** module chunks = 0
 **/